// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#payment-iframe-frame {
  border: none;
  width: 100%;
  height: 450px;
  overflow: auto;
}
.credit-card-info {
  display: flex;
  gap: 10px;
}
.credit-card-info > div:nth-child(1) {
  width: 50px;
}
.credit-card-info > div:nth-child(2) {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/BookingPersonal.vue","webpack://./BookingPersonal.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;ACAF;ADGA;EACE,aAAA;EACA,SAAA;ACAF;ADEE;EACE,WAAA;ACAJ;ADEE;EACE,OAAA;ACAJ","sourcesContent":["\r\n#payment-iframe-frame {\r\n  border: none;\r\n  width: 100%;\r\n  height: 450px;\r\n  overflow: auto;\r\n}\r\n\r\n.credit-card-info {\r\n  display: flex;\r\n  gap: 10px;\r\n\r\n  > div:nth-child(1) {\r\n    width: 50px;\r\n  }\r\n  > div:nth-child(2) {\r\n    flex: 1;\r\n  }\r\n}\r\n","#payment-iframe-frame {\n  border: none;\n  width: 100%;\n  height: 450px;\n  overflow: auto;\n}\n\n.credit-card-info {\n  display: flex;\n  gap: 10px;\n}\n.credit-card-info > div:nth-child(1) {\n  width: 50px;\n}\n.credit-card-info > div:nth-child(2) {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
